import { ModelingStatus } from "./index";

import store from "../store";
import { updateConfigStatus } from "../store/actions/workspace";

export default class UpdateStore {
  /**
   * Update config status in store (workspace.workspace.ModellingStatus)
   * @param {Object} response sent from backend on fetchAPI get/post/patch/delete
   * @param {Number} modifiedStatus status to update in store
   * @returns
   */
  async updateConfigStatus(response, modifiedStatus = null) {
    if (modifiedStatus === null) modifiedStatus = store.getState()?.workspace?.workspace?.ModelingStatus || null;
    store.dispatch(updateConfigStatus(modifiedStatus));
    return response;
  }

  /**
   * Update config status in store
   * Used specifically for workspace import
   * @param {Object} response
   * @returns
   */
  async updateOnImportSuccess(response) {
    const { datasources, entities } = response?.data?.data ?? {};
    let configStatus;
    let isUpdated = false;

    if (datasources) isUpdated = datasources?.some((ds) => ds.Success);
    if (entities && !isUpdated) isUpdated = entities?.some((ent) => ent.Success);

    return this.updateConfigStatus(response, isUpdated ? ModelingStatus.Modified : configStatus);
  }
}
